export default __webpack_public_path__ + "assets/images/aistudio/a8c42ce261d2d1c6a01bfc844999a763.png";